import clsx from "clsx";
import { MouseEventHandler, PropsWithChildren } from "react";

export const QuoteCardButton: React.FC<
  PropsWithChildren<{
    theme: "normal" | "highlighted";
    className?: string;
    onClick: MouseEventHandler<HTMLButtonElement>;
  }>
> = ({ theme, className, onClick, children }) => (
  <button
    className={clsx(
      `focus:shadow-outline flex min-h-12 items-center justify-center rounded px-4 py-3 text-lg font-bold transition-colors duration-150 focus:outline-none`,
      theme === "normal"
        ? "border border-dm-charcoal-800 bg-white text-black hover:bg-dm-gray-100"
        : "bg-dm-earth-yellow-500 hover:bg-dm-earth-yellow-600",
      className
    )}
    onClick={onClick}
  >
    {children}
  </button>
);
